var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.936 15.757L28.7512 6.98469H8.84263L8.13263 4.7709C7.73573 3.53231 6.98061 2.50829 5.99895 1.79185C5.01545 1.07448 3.80909 0.669292 2.51065 0.669292H1.50137C1.11644 0.669292 0.80426 0.981471 0.80426 1.3664C0.80426 1.75225 1.11644 2.06351 1.50137 2.06351H2.51065C3.51349 2.06351 4.43621 2.37016 5.18121 2.9144C5.92712 3.45864 6.50267 4.24323 6.8084 5.19634L7.38211 6.98561L10.1972 15.7579C10.6439 17.1512 11.8871 18.0574 13.3503 18.0574H22.7829C24.2462 18.0574 25.4894 17.1512 25.936 15.7579V15.757ZM22.2746 20.0575C23.5482 20.0575 24.5805 21.0898 24.5805 22.3634C24.5805 23.637 23.5482 24.6693 22.2746 24.6693C21.001 24.6693 19.9687 23.637 19.9687 22.3634C19.9687 21.0898 21.001 20.0575 22.2746 20.0575ZM13.8587 20.0575C15.1322 20.0575 16.1646 21.0898 16.1646 22.3634C16.1646 23.637 15.1322 24.6693 13.8587 24.6693C12.5851 24.6693 11.5528 23.637 11.5528 22.3634C11.5528 21.0898 12.5851 20.0575 13.8587 20.0575Z",
    fill: "#4D5C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.5354b23770fef48bc02d87e1ce5d0962.svg";
export { ForwardRef as ReactComponent };